import { decimalUnits, unitsToDecimal, hasPlanCoverage, isPartnerModel } from './generation-request.js';

export function videoEstimateParameters(config) {
  return { model: config.modelId, network: config.network, tokenType: config.tokenType,
    billingMode: config.billingMode, width: config.width, height: config.height,
    ...(config.frames !== undefined ? { frames: config.frames } : { duration: config.duration }),
    fps: config.fps, ...(config.steps !== undefined ? { steps: config.steps } : {}),
    numberOfMedia: config.numberOfMedia, referenceImageCount: 1 };
}

// The public video estimate has no member adjustment: Socket applies this
// active-account benefit when admitting a premium partner project. Keep its
// existing retail markup and compose the live basis points with that quote.
export async function estimateExactVideoCost(client, params, model, subscription) {
  const cost = await client.projects.estimateVideoCost(params);
  const discountBpsApplied = isPartnerModel(model) && hasPlanCoverage(subscription)
    ? subscription.frontierDiscountBps || 0 : 0;
  if (!discountBpsApplied) return { ...cost, discountBpsApplied: 0 };
  const discounted = {};
  for (const currency of ['token', 'usd', 'spark', 'sogni']) {
    if (cost[currency] === undefined) continue;
    const numerator = decimalUnits(cost[currency]) * BigInt(10000 - discountBpsApplied);
    discounted[currency] = unitsToDecimal(numerator / 10000n + (numerator % 10000n > 0n ? 1n : 0n));
  }
  return { ...cost, ...discounted, discountBpsApplied };
}
